// 정적 원고 읽기 — public/content/*.md (또는 프리뷰 빌드의 window.__DOCS__).
//
// 2026-09-06 부터 사이트는 docs/DocsContext.jsx 를 통해 원고를 읽는다. REACT_APP_DOCS_FEED_URL 이 있으면
// docs-feed 함수(lib/docsFeed.js)가, 없으면 이 파일이 쓰인다. 화면 컴포넌트는 이 함수를 직접 부르지 말고
// useDocs().loadDoc 을 쓴다 — 두 모드를 여기서 가르면 원장이 두 벌이 된다.
export function loadStaticDoc(slug) {
  const embedded = typeof window !== 'undefined' && window.__DOCS__;
  if (embedded && typeof embedded[slug] === 'string') {
    return Promise.resolve(embedded[slug]);
  }
  return fetch(`${process.env.PUBLIC_URL}/content/${slug}.md`).then((r) => {
    if (!r.ok) throw new Error(String(r.status));
    return r.text();
  });
}
